function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useEffect, useState } from 'react';
import HedinIcon from "../../../icons/components/HedinIcon";
import useTranslation from "../../../utils/hooks/translation";
var refExists = function refExists(currentRef) {
  var _current;
  return !!(currentRef !== null && currentRef !== void 0 && (_current = currentRef.current) !== null && _current !== void 0 && _current.style);
};
export var Collapse = function Collapse(props) {
  var children = props.children,
    buttonText = props.buttonText,
    ShowText = props.showText,
    HideText = props.hideText,
    _props$hasButton = props.hasButton,
    hasButton = _props$hasButton === void 0 ? true : _props$hasButton,
    expanded = props.expanded,
    updateMaxHeight = props.updateMaxHeight;
  var t = useTranslation();
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isExpanded = _useState2[0],
    setIsExpanded = _useState2[1];
  var collapseIsOpenClass = isExpanded ? 'collapse__body-open' : '';
  var buttonIsOpenClass = isExpanded ? 'button__expanded' : '';
  var collapseRef = React.useRef(null);
  var show = t('collapseShow') || 'Visa';
  var hide = t('collapseHide') || 'Dölj';
  var showText = ShowText || show;
  var hideText = HideText || hide;
  useEffect(function () {
    var _newRef$current;
    var newRef = collapseRef;
    if (!(newRef !== null && newRef !== void 0 && (_newRef$current = newRef.current) !== null && _newRef$current !== void 0 && _newRef$current.style)) return;
    if (!expanded) {
      var _newRef$current2;
      newRef.current.style.maxHeight = "".concat(newRef === null || newRef === void 0 || (_newRef$current2 = newRef.current) === null || _newRef$current2 === void 0 ? void 0 : _newRef$current2.scrollHeight, "px");
      setTimeout(function () {
        if (!refExists(newRef)) return;
        newRef.current.style.maxHeight = '0';
      }, 50);
    } else {
      var _newRef$current3;
      newRef.current.style.maxHeight = "".concat(newRef === null || newRef === void 0 || (_newRef$current3 = newRef.current) === null || _newRef$current3 === void 0 ? void 0 : _newRef$current3.scrollHeight, "px");
      setTimeout(function () {
        if (!refExists(newRef)) return;
        newRef.current.style.maxHeight = 'initial';
      }, 200);
    }
    setIsExpanded(expanded);
  }, [expanded]);
  useEffect(function () {
    var _newRef$current4;
    var newRef = collapseRef;
    if (!(newRef !== null && newRef !== void 0 && (_newRef$current4 = newRef.current) !== null && _newRef$current4 !== void 0 && _newRef$current4.style)) return;
    if (expanded) {
      setTimeout(function () {
        var _newRef$current5;
        if (!refExists(newRef)) return;
        newRef.current.style.maxHeight = "".concat(newRef === null || newRef === void 0 || (_newRef$current5 = newRef.current) === null || _newRef$current5 === void 0 ? void 0 : _newRef$current5.scrollHeight, "px");
        setTimeout(function () {
          if (!refExists(newRef)) return;
          newRef.current.style.maxHeight = 'initial';
        }, 60);
      }, 200);
    }
  }, [expanded, updateMaxHeight]);
  var onToggle = function onToggle() {
    var _newRef$current6;
    var newRef = collapseRef;
    if (!(newRef !== null && newRef !== void 0 && (_newRef$current6 = newRef.current) !== null && _newRef$current6 !== void 0 && _newRef$current6.style)) return;
    if (isExpanded) {
      newRef.current.style.maxHeight = '0';
    } else {
      var _newRef$current7;
      newRef.current.style.maxHeight = "".concat(newRef === null || newRef === void 0 || (_newRef$current7 = newRef.current) === null || _newRef$current7 === void 0 ? void 0 : _newRef$current7.scrollHeight, "px");
    }
    setIsExpanded(!isExpanded);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "collapse"
  }, /*#__PURE__*/React.createElement("div", {
    className: "collapse__body ".concat(collapseIsOpenClass),
    ref: collapseRef
  }, children), hasButton && /*#__PURE__*/React.createElement("button", {
    className: "button button--naked product-page__button ".concat(buttonIsOpenClass),
    onClick: function onClick() {
      return onToggle();
    }
  }, isExpanded ? hideText : showText, " ", buttonText, /*#__PURE__*/React.createElement(HedinIcon, {
    iconName: "ChevronDown",
    className: "float-right product-page__button-icon"
  })));
};